<nes-section>
  <nes-container variant="narrow">
    <router-outlet></router-outlet>
  </nes-container>
</nes-section>
